const PAGE_SIZE_KEY = 'preferred_page_sizes';
const DEFAULT_PAGE_SIZE = 10;

const getAllPageSizes = () => {
  try {
    const saved = localStorage.getItem(PAGE_SIZE_KEY);
    if (saved) {
      const pageSizes = JSON.parse(saved);
      if (typeof pageSizes === 'object' && pageSizes !== null) {
        return pageSizes;
      }
    }
  } catch (error) {
    console.error('Error reading page sizes from localStorage:', error);
  }
  return {};
};

const saveAllPageSizes = (pageSizes) => {
  try {
    localStorage.setItem(PAGE_SIZE_KEY, JSON.stringify(pageSizes));
  } catch (error) {
    console.error('Error saving page sizes to localStorage:', error);
  }
};

export const getPreferredPageSize = (moduleKey = 'default') => {
  try {
    const pageSizes = getAllPageSizes();
    if (pageSizes[moduleKey]) {
      const parsed = parseInt(pageSizes[moduleKey], 10);
      if (!isNaN(parsed) && parsed > 0) {
        return parsed;
      }
    }
  } catch (error) {
    console.error('Error reading page size preference:', error);
  }
  return DEFAULT_PAGE_SIZE;
};

export const savePreferredPageSize = (pageSize, moduleKey = 'default') => {
  try {
    if (pageSize && pageSize > 0) {
      const pageSizes = getAllPageSizes();
      pageSizes[moduleKey] = pageSize.toString();
      saveAllPageSizes(pageSizes);
    }
  } catch (error) {
    console.error('Error saving page size preference:', error);
  }
};
